/**
 * PIK Cart Guard - Prevents shell products from being added to cart
 *
 * Shell products (rectangular-drop-in-liner, circular-drop-in-liner) are
 * customer-facing pages that mount a React configurator. They should never
 * be added to cart directly - only the backend variants should be added.
 *
 * This script monitors the cart and removes any shell products that slip through.
 */
(function() {
  'use strict';

  // Shell product handles that should never be in cart
  var SHELL_HANDLES = [
    'rectangular-drop-in-liner',
    'circular-drop-in-liner'
  ];

  // Debounce timer to avoid multiple rapid checks
  var checkTimeout = null;

  /**
   * Check cart for shell products and remove them
   */
  function checkAndCleanCart() {
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      var itemsToRemove = [];

      cart.items.forEach(function(item) {
        if (SHELL_HANDLES.indexOf(item.handle) !== -1) {
          itemsToRemove.push(item.key);
        }
      });

      if (itemsToRemove.length > 0) {
        removeShellItems(itemsToRemove);
      }
    })
    .catch(function(err) {
      console.error('[PIK Cart Guard] Error checking cart:', err);
    });
  }

  /**
   * Remove shell items from cart
   */
  function removeShellItems(keys) {
    var updates = {};
    keys.forEach(function(key) {
      updates[key] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      // Show brief notification
      showNotification('Please use the configurator to customize your liner before adding to cart.');

      // Trigger cart refresh for theme to update UI
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false }
      }));
    })
    .catch(function(err) {
      console.error('[PIK Cart Guard] Error removing items:', err);
    });
  }

  /**
   * Show a brief, non-intrusive notification
   */
  function showNotification(message) {
    // Check if notification already exists
    var existing = document.getElementById('pik-cart-guard-notification');
    if (existing) {
      existing.remove();
    }

    var notification = document.createElement('div');
    notification.id = 'pik-cart-guard-notification';
    notification.style.cssText = [
      'position: fixed',
      'bottom: 20px',
      'left: 50%',
      'transform: translateX(-50%)',
      'background: #1e3a5f',
      'color: white',
      'padding: 12px 24px',
      'border-radius: 8px',
      'font-size: 14px',
      'z-index: 9999',
      'box-shadow: 0 4px 12px rgba(0,0,0,0.15)',
      'max-width: 90%',
      'text-align: center',
      'animation: pikSlideUp 0.3s ease'
    ].join(';');
    notification.textContent = message;

    // Add animation keyframes if not present
    if (!document.getElementById('pik-cart-guard-styles')) {
      var style = document.createElement('style');
      style.id = 'pik-cart-guard-styles';
      style.textContent = '@keyframes pikSlideUp { from { opacity: 0; transform: translateX(-50%) translateY(20px); } to { opacity: 1; transform: translateX(-50%) translateY(0); } }';
      document.head.appendChild(style);
    }

    document.body.appendChild(notification);

    // Auto-remove after 4 seconds
    setTimeout(function() {
      if (notification.parentNode) {
        notification.style.opacity = '0';
        notification.style.transition = 'opacity 0.3s ease';
        setTimeout(function() {
          if (notification.parentNode) {
            notification.remove();
          }
        }, 300);
      }
    }, 4000);
  }

  /**
   * Debounced cart check
   */
  function scheduleCartCheck() {
    if (checkTimeout) {
      clearTimeout(checkTimeout);
    }
    checkTimeout = setTimeout(checkAndCleanCart, 100);
  }

  // Listen for Warehouse theme's cart events
  document.addEventListener('product:added', scheduleCartCheck);
  document.addEventListener('cart:refresh', scheduleCartCheck);
  document.addEventListener('cart:updated', scheduleCartCheck);

  // Also intercept fetch calls to /cart/add.js as a backup
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    var result = originalFetch.apply(this, arguments);

    // Check if this is a cart add request
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      result.then(function() {
        scheduleCartCheck();
      });
    }

    return result;
  };

  // Initial check on page load (in case cart already has shell items)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCartCheck);
  } else {
    scheduleCartCheck();
  }
})();
